(function () {

    angular
        .module('auth.srv', [])
        .constant('AUTH_EVENTS', {
            loginSuccess: 'auth-login-success',
            loginFailed: 'auth-login-failed',
            logoutSuccess: 'auth-logout-success',
            sessionTimeout: 'auth-session-timeout',
            notAuthenticated: 'auth-not-authenticated',
            notAuthorized: 'auth-not-authorized',
            benchmarkLoginUrl: 'https://ui.benchmarkemail.com/gotojb',
            maintenancePage: 'https://app.benchmarkemail.com/automationpro',
            benchmarkUi: 'https://ui.benchmarkemail.com/',
            benchmarkScriptApp: 'https://scriptapp.benchmarkemail.com/',
            benchmarkScriptAppURLTemplate: 'tkn/229C5A3C-2854-41E6-AB6A-50BA3571CBF2?c=##c##&rdn=##rdn##'
        })
        .service('Session', ['AUTH_EVENTS', function (AUTH_EVENTS) {
            var setCookie = function (cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + "; " + expires;
            };

            this.create = function (sessionName, sessionVal) {
                setCookie(sessionName, sessionVal);
            };

            this.destroy = function () {
                document.cookie = 'BenchmarkToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            };

            this.getCookie = function (cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            };

            this.getTokenViaAPI = function () {
                try {
                    let p = "Z12";
                    let rdn = Date.now() + "" + Math.floor(Math.random() * 90000000);
                    let url = AUTH_EVENTS.benchmarkScriptApp + AUTH_EVENTS.benchmarkScriptAppURLTemplate.replace('##c##', p).replace('##rdn##', rdn);
                    return fetch(url, {
                        method: 'POST',
                        credentials: 'include',
                        cache: 'no-store',
                        headers: {
                            'Cache-Control': 'no-cache, no-store, must-revalidate',
                            'Pragma': 'no-cache',
                            'Expires': '0'
                        }
                    }).then(function(response) {
                        return response.json();
                    })
                    .then(function(data) {
                        return data[p];
                    });
                } catch(ex) {
                    return "";
                }
            };

            this.getClientDetailsViaAPI = function () {
                try {
                    let p = "A62";
                    let rdn = Date.now() + "" + Math.floor(Math.random() * 90000000);
                    let url = AUTH_EVENTS.benchmarkScriptApp + AUTH_EVENTS.benchmarkScriptAppURLTemplate.replace('##c##', p).replace('##rdn##', rdn);
                    return fetch(url, {
                        method: 'POST',
                        credentials: 'include',
                        cache: 'no-store',
                        headers: {
                            'Cache-Control': 'no-cache, no-store, must-revalidate',
                            'Pragma': 'no-cache',
                            'Expires': '0'
                        }
                    }).then(function(response) {
                        return response.json();
                    })
                    .then(function(data) {
                        return data[p];
                    });
                } catch(ex) {
                    return {"t":"","c":"","f":"","l":""};
                }
            };
        }])
        .factory('AuthSrv', ['$rootScope', 'Session', 'uiService', '$http', 'API_OPTS', '$q', auth]);

    function auth($rootScope, Session, uiService, $http, API_OPTS, $q) {
        var isAuthenticated = function () {
            var token = Session.getCookie('BenchmarkToken'),
                lang = Session.getCookie('L');

            if (token) {
                $rootScope.jbToken = token;
                $rootScope.jbLang = getLangVal(lang);
                return $q.resolve(true);
            } else {
                return Session.getTokenViaAPI().then(function(apiToken) {
                    if (apiToken) {
                        $rootScope.jbToken = apiToken;
                        $rootScope.jbLang = getLangVal(lang);
                        return true;
                    }
                    return false;
                }).catch(function() {
                    return false;
                });
            }
        };

        var destroySession = function() {
            Session.destroy();
        };

        var getCurrentSession = function () {
            var token = Session.getCookie('BenchmarkToken'),
                lang = Session.getCookie('L');

            if (token) {
                return $q.resolve({
                    token: token,
                    lang: lang
                });
            } else {
                return Session.getTokenViaAPI().then(function(apiToken) {
                    return {
                        token: apiToken,
                        lang: lang
                    };
                });
            }
        };


        var authUser = function(token) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CSETTING, {
                headers: {'Authorization': 'OAuth ' + token}
            });
        };

        function getLangVal(lang) {

            var cLang = lang.toLowerCase(),
                hasLang = [
                'spanish',
                'english',
                'chinese',
                'chineset',
                'german',
                'japanese',
                'italian',
                'portuguese',
                'brazil',
                'french',
                'indian'
            ].indexOf(cLang);

            if(hasLang === -1) {
                cLang = 'english';
            }

            return cLang;
        }

        function getUrlParam(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }

        return {
            isAuthenticated: isAuthenticated,
            authUser: authUser,
            getParamUrl: getUrlParam,
            getCurrentSession: getCurrentSession,
            destroySession: destroySession,
            hasToken: function() {
                return !!Session.getCookie('BenchmarkToken');
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/services/auth.service.js